import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { SubidaDocumentoPlantillaComponent } from './subida-documento-plantilla';

@NgModule({
  declarations: [SubidaDocumentoPlantillaComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    SubidaDocumentoPlantillaComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class SubidaDocumentoPlantillaModule { }
